import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { IApplication } from 'src/app/model/iapplication';
import { IQualificationBasis } from 'src/app/model/qualifications/iqualification-basis';
import { IQualificationGroup } from 'src/app/model/qualifications/iqualification-group';
import { ITag } from 'src/app/model/tag/itag';
import { PAGE_NAMES } from './application-names';
import { CustomValidators } from './custom-validators';

export const APPLICATION_FORM_DEF: (input?: IApplication) => { [key: string]: any } =
    (input?: IApplication) => ({
        applicantSsn: [null, CustomValidators.ssn],
        dateOfArrival: [null, CustomValidators.nonForwardDate],
        payment: [null],
        skolverketCaseId: [null],
        tags: TAGS_DEF(input ? input.tags : null),
        type: [null, Validators.required],
        userConfirmation: [null, Validators.requiredTrue],
    });

const TAGS_DEF: (tags: ITag[]) => UntypedFormArray =
    (tags: ITag[]) => {
        const array = new UntypedFormArray([]);
        if (tags) {
            tags.map((tag: ITag) => new UntypedFormGroup({
                standardTag: new UntypedFormControl(tag.standardTag),
                value: new UntypedFormControl(tag.value),
            }))
                .forEach((group: UntypedFormGroup) => array.push(group));
        }
        return array;
    };

export const APPLICANT_FORM_DEF: { [key: string]: any } = {
    applicantAddress: [null, Validators.required],
    applicantCity: [null],
    applicantName: [null],
    applicantPhone: [null, [CustomValidators.phone]],
    applicantPostalCode: [null],
};

export const EXAMINA_FORM_DEF: { [key: string]: any } = {
    code: [null, Validators.required],
    name: [null],
    year: [null, Validators.required],
};

export const DEGREE_ONE_FORM_DEF: (fb: UntypedFormBuilder) => { [key: string]: any } =
    (fb: UntypedFormBuilder) => ({
        firstExamina: fb.group(EXAMINA_FORM_DEF),
    });

export const DEGREE_TWO_FORM_DEF: (fb: UntypedFormBuilder) => { [key: string]: any } =
    (fb: UntypedFormBuilder) => ({
        firstExamina: fb.group(EXAMINA_FORM_DEF),
        secondExamina: fb.group(EXAMINA_FORM_DEF),
    });

export const SPECIAL_EDUCATION_FORM_DEF: (optional?: boolean) => { [key: string]: any } =
    (optional?: boolean) => ({
        specialEducationTeacher: optional ? [null] : [null, Validators.required],
    });

export const QUALIFICATION_GROUP_FORM_DEF =
    (fb: UntypedFormBuilder, input?: IQualificationGroup) => {
        const qualifications = input ?
            input.qualifications.map((qualification) => {
                const group = fb.group(QUALIFICATION_FORM_DEF());
                group.patchValue(qualification);
                // Add bases.
                const bases = group.get(PAGE_NAMES.OTHER_QUALIFICATION.QUALIFICATIONS.BASES.KEY) as UntypedFormArray;
                qualification.bases.forEach((basis) => bases.push(fb.group(QUALIFICATION_BASIS_GROUP_FORM_DEF(basis))));
                return group;
            })
            : [];
        return { qualifications: fb.array(qualifications) };
    };

export const QUALIFICATION_FORM_DEF: () => { [key: string]: any } = () => ({
    bases: new UntypedFormArray([], Validators.required),
    languageCode: [null],
    languageName: [null],
    orientationCode: [null],
    orientationName: [null],
    studyPathCode: [null],
    studyPathName: [null],
    subjectCode: [null],
    subjectName: [null],
    typeCode: [null, Validators.required],
    typeName: [null, Validators.required],
    typeOfSchoolingCode: [null],
    typeOfSchoolingName: [null],
});

export const QUALIFICATION_BASIS_GROUP_FORM_DEF = (basis: IQualificationBasis) => {
    const def = QUALIFICATION_BASIS_FORM_DEF(Boolean(basis.yearIntervals), Boolean(basis.fromYear));
    if (basis.yearIntervals) {
        const intervals = def.yearIntervals as UntypedFormArray;
        basis.yearIntervals.map((i) => intervals.push(new UntypedFormControl(i)));
    }
    return def;
};

export const QUALIFICATION_BASIS_FORM_DEF: (intervals: boolean, freeYear: boolean) => { [key: string]: any } =
    (intervals: boolean, freeYear: boolean) => ({
        fromYear: freeYear ? [null, Validators.required] : [null],
        toYear: freeYear ? [null, Validators.required] : [null],
        typeCode: [null, Validators.required],
        typeName: [null, Validators.required],
        yearIntervals: intervals ? new UntypedFormArray([], Validators.required) : [null],
    });

export const ATTACHMENTS_FORM_DEF: () => { [key: string]: any } =
    () => ({
        attachments: new UntypedFormArray([]),
        deliveryMethod: [null, Validators.required],
    });

export const ATTACHMENT_FORM_DEF: { [key: string]: any } = {
    content: [null, Validators.required],
    fileName: [null, Validators.required],
    size: [null],
};

export const SUPPLEMENT_FORM_DEF: () => { [key: string]: any } =
    () => ({
        applicantEmail: [null, [Validators.required, Validators.email]],
        applicantPhone: [null, [CustomValidators.phone]],
        applicantSsn: [null, [Validators.required, CustomValidators.ssn]],
        applicantText: [null, [Validators.maxLength(2000)]],
        attachments: new UntypedFormGroup({
            attachments: new UntypedFormArray([]),
        }),
    });
